// extracted by mini-css-extract-plugin
module.exports = {"sponsoredBanner":"Hm-z","sponsoredTooltipWrapper":"Im-z","sponsoredTooltip":"Jm-z","newCard":"Km-z"};